<template>
  <v-tooltip bottom v-if="showTooltip">
    <template v-slot:activator="{ on }">
      <span v-on="on">{{ value }}</span>
    </template>
    <span>{{ value }}</span>
  </v-tooltip>
  <span v-else>{{ value }}</span>
</template>

<script>
export default {
  name: "truncated-label",

  props: {
    width: {
      type: Number,
      default: () => 100,
    },
    value: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    showTooltip() {
      return this.value.length > this.width;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/TruncatedLabel.vue